<script setup lang="ts">
import { LucideChevronRight } from 'lucide-vue-next'
import NewsContent from './NewsContent.vue'
import type { IResponseData } from '~/types'
import type { INewsCategory } from '~/components/entity/news-category'

const { data: newsCategories } = useApi<IResponseData<INewsCategory[]>>(
  () => useUrlWithParams('/news_categories?filter[position]=mainpage'),
  {
    key: 'home-page.news-categories'
  }
)
</script>

<template>
  <div class="space-y-5 sm:space-y-6">
    <header class="flex flex-wrap items-center justify-between gap-1.5 pb-4 sm:gap-8">
      <Heading tag="h2" class="mb-4 sm:mb-0">{{ $t('widget.home_page.news.heading') }}</Heading>
      <div class="flex flex-col items-start gap-3 md:flex-row md:items-center">
        <ScrollArea v-if="newsCategories" class="w-fit">
          <div class="flex flex-wrap gap-3">
            <NuxtLinkLocale
              v-for="category in newsCategories.data"
              :key="category.id"
              :to="category.url"
              class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-gray-100 bg-white px-3 py-2 text-sm font-semibold transition-all hover:bg-blue-600 hover:text-white focus-visible:outline-none [&_svg]:shrink-0"
            >
              <i class="[&>svg]:size-4"><UiIcon :name="category.slug" /></i>
              {{ category.title }}
            </NuxtLinkLocale>
          </div>
          <ScrollBar orientation="horizontal" />
        </ScrollArea>
        <Button variant="link" size="auto" class="mt-3 md:mt-0" as-child>
          <NuxtLinkLocale to="/news">
            {{ $t('widget.home_page.news.view_all') }}
            <LucideChevronRight />
          </NuxtLinkLocale>
        </Button>
      </div>
    </header>
    <div class="space-y-3 sm:space-y-5">
      <NewsContent />
    </div>
  </div>
</template>
